import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuizParticipants,
  getQuizParticipantsOld,
  getQuizzes,
  getRegisteredQuizUsersList,
  getUsersList,
} from "../redux/thunk";
import { setState } from "../redux/slice";
import CommonTable from "../../components/LawCollegeQuiz/CommonTable";
import { formatDuration } from "../utils";

export default function UserManagement() {
  const dispatch = useDispatch();
  const {
    usersList,
    option_selected,
    quizzes,
    selectedQuizId,
    subFilterBy,
    filteredUsersList,
    registeredList,
    practiceList,
    selectedQuizData,
  } = useSelector((state) => state.quizManagement);
  useEffect(() => {
    dispatch(getUsersList());
    dispatch(getQuizzes());
    dispatch(
      setState({
        key: "option_selected",
        value: 1,
      })
    );
  }, [dispatch]);

  const handleTabChange = (value) => {
    dispatch(
      setState({
        key: "option_selected",
        value,
      })
    );
    dispatch(
      setState({
        key: "filteredUsersList",
        value: [],
      })
    );
    dispatch(
      setState({
        key: "selectedQuizId",
        value: "",
      })
    );
  };
  const handleSubTabChange = async (value) => {
    dispatch(
      setState({
        key: "subFilterBy",
        value,
      })
    );
    if (value === 5) {
      await dispatch(getRegisteredQuizUsersList({ id: selectedQuizId }));
    }
    // dispatch(
    //   setState({
    //     key: "filteredUsersList",
    //     value: [],
    //   })
    // );
  };

  console.log(filteredUsersList);

  // Common button style
  const btnStyle = {
    padding: "8px 16px",
    borderRadius: "6px",
    fontWeight: "500",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
  };
  function ReusableTable({ columns = [], rows = [] }) {
    if (!rows || rows.length === 0) {
      return (
        <p className="text-center text-gray-500 py-6 text-lg">
          No data available
        </p>
      );
    }

    return (
      <table className="table table-striped table-bordered text-15 w-full">
        <thead>
          <tr style={{ backgroundColor: "#e5e7eb", color: "#374151" }}>
            <th>Sl NO.</th>
            {columns.map((col, index) => (
              <th key={index} className="text-center px-4 py-2">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id || rowIndex} className="hover:bg-gray-100">
              <td>{rowIndex + 1}</td>
              {columns.map((col, colIndex) => (
                <td key={colIndex} className="text-center px-4 py-2">
                  {/* If accessor function exists, use it, otherwise use key */}
                  {typeof col.accessor === "function"
                    ? col.accessor(row, rowIndex)
                    : row[col.key] ?? "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  const columns = [
    { key: "slno", label: "Slno." },
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "mobile_number", label: "Mobile Number" },
    {
      key: "status",
      label: "Status",
    },
    { key: "score", label: "Score" },
    { key: "position", label: "Position" },
    { key: "qualified", label: "Qualified" },
    { key: "total_time_taken_ms", label: "Time Taken (s)" },
    { key: "registered_at", label: "Registered At" },
    { key: "completed_at", label: "Completed At" },
    { key: "action", label: "View Results" },
  ];
  const columns_new = [
    // { key: "user_id", label: "User Id." },
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "mobile_number", label: "Mobile Number" },
    { key: "score", label: "Score" },
    { key: "position", label: "Position" },
    { key: "total_time_taken_ms", label: "Time Taken (s)" },
  ];
  const handleGetResult = async (quiz) => {
    try {
      const response = await fetch(
        `https://web1024.docmaster.in:5007/api/quiz/admin/results?quiz_id=${quiz.quiz_id}&user_id=${quiz.user_id}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);
      dispatch(
        setState({
          key: "selectedQuizData",
          value: data,
        })
      );
      // setSelectedQuiz(data);
    } catch (err) {
      console.error("Error fetching completed quizzes:", err);
    }
  };

  // const handleGetResult = (data) => {
  //   console.log(JSON.stringify(data));
  // };
  const tableData = filteredUsersList?.data?.map((q, index) => ({
    slno: index + 1, // add serial no. here
    id: q.user_id,
    name: q.name || "-",
    email: q.email_id || "-",
    mobile_number: q.mobile_no || "-",
    score: q.score || "-",
    position: q.position || "-",
    total_time_taken_ms:
      q.status !== "registered" && q.total_time_taken_ms
        ? // ? formatDuration((q.total_time_taken_ms / 1000).toFixed(2))
          formatDuration(Math.floor(q.total_time_taken_ms / 1000))
        : "-",
    status: q?.status || "-",
    qualified:
      q.qualify_status === 1 ? "Yes" : q.qualify_status === 0 ? "No" : " - ",
    registered_at: q.registered_at
      ? new Date(q.registered_at).toLocaleString("en-IN", {
          day: "2-digit",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "-",
    completed_at: q.completed_at
      ? new Date(q.completed_at).toLocaleString("en-IN", {
          day: "2-digit",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "-",
    action:
      q.status === "participated" ? (
        <img
          width="24"
          height="24"
          style={{ cursor: "pointer" }}
          onClick={() => handleGetResult(q)}
          src="https://img.icons8.com/material-rounded/24/visible.png"
          alt="visible"
        />
      ) : (
        "-"
      ),
  }));

  return (
    <div>
      <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative ">
        <div
          style={{
            marginTop: "2%",
            display: "flex",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          {[
            { id: 1, label: "General Users" },
            { id: 2, label: "Participants of Live Quiz" },
            { id: 3, label: "Participants of Practice Quiz" },
          ].map((tab) => {
            const isActive = option_selected === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                style={{
                  flex: 1, // ✅ equal width
                  padding: "10px 0",
                  borderRadius: "6px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: isActive ? "#007bff" : "#fff", // ✅ blue bg on active
                  color: isActive ? "#fff" : "#007bff", // ✅ white text on active, blue on inactive
                  border: `2px solid ${isActive ? "#007bff" : "#007bff"}`, // ✅ blue border always
                  boxShadow: isActive
                    ? "0px 4px 8px rgba(37, 99, 235, 0.4)" // ✅ shadow only when active
                    : "none",
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div
          className="table-responsive p-2 rounded-3"
          style={{ height: "60vh", overflow: "auto" }}
        >
          {/* General Users Table */}
          {option_selected === 1 ? (
            <table className="table table-striped table-bordered text-15 w-full">
              <thead>
                <tr style={{ backgroundColor: "#e5e7eb", color: "#374151" }}>
                  <th className="text-center" style={{ width: "10px" }}>
                    Sl No.
                  </th>
                  <th className="text-center">Name</th>
                  <th className="text-center">Email</th>
                  <th className="text-center" style={{ width: "10%" }}>
                    Mobile Number
                  </th>
                  {/* <th className="text-center">Date Of Birth</th>
                  <th className="text-center">College Name</th>
                  <th className="text-center">College Roll No.</th>
                  <th className="text-center">Role</th> */}
                  <th className="text-center">Role</th>
                  <th className="text-center">Registered At</th>
                </tr>
              </thead>

              <tbody>
                {usersList?.users?.length > 0 &&
                  usersList?.users?.map((q, index) => (
                    <tr key={q.id} className="hover:bg-gray-100">
                      <td className="text-center">{index + 1}</td>
                      <td style={{ paddingLeft: "1%" }}>{q.name}</td>
                      <td style={{ paddingLeft: "1%" }}>{q.email_id || "-"}</td>
                      <td className="text-center">{q.mobile_no || "-"}</td>
                      {/* <td className="text-center">
                        {q.date_of_birth
                          ? new Date(q.date_of_birth).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </td>
                      <td className="text-center">{q.college_name || "-"}</td>
                      <td className="text-center">
                        {q.college_roll_number || "-"}
                      </td>
                      <td className="text-center">{q.role || "-"}</td> */}
                      <td className="text-center">{q.role || "-"}</td>
                      <td className="text-center">
                        {q.created_on
                          ? new Date(q.created_on).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <div>
              <label style={{ padding: "16px", color: "#4b5563" }}>
                {option_selected === 2
                  ? "Choose a live Quiz"
                  : "Choose a practice quiz"}
                :
                <select
                  className="form-input"
                  value={selectedQuizId}
                  onChange={async (e) => {
                    const { value } = e.target;
                    dispatch(
                      setState({
                        key: "selectedQuizId",
                        value: value,
                      })
                    );
                    if (value && option_selected === 2) {
                      await dispatch(
                        getQuizParticipants({
                          quiz_id: value,
                          // status: "",
                          // search: "",
                          limit: 100,
                          offset: 0,
                        })
                      );
                    }
                    if (value && option_selected === 3) {
                      await dispatch(
                        getQuizParticipantsOld({
                          quiz_id: value,
                        })
                      );
                    }
                  }}
                >
                  <option value={""}>Select</option>
                  {quizzes
                    .filter(
                      (e) =>
                        e.quiz_type ===
                        (option_selected === 2
                          ? 1
                          : option_selected === 3
                          ? 2
                          : null)
                    )
                    .map((quiz) => (
                      <option key={quiz.id} value={quiz.id}>
                        {quiz.title}
                      </option>
                    ))}{" "}
                </select>
              </label>
            </div>
          )}

          {option_selected === 2 && selectedQuizId && (
            <div>
              <CommonTable
                total={filteredUsersList.total_count}
                filteredCount={filteredUsersList.filtered_count}
                columns={columns}
                data={tableData || []}
                initialRowsPerPage={100}
                searchableKeys={["name", "email", "mobile_number", "status"]}
                fetchData={({ limit, offset }) =>
                  dispatch(
                    getQuizParticipants({
                      quiz_id: selectedQuizId,
                      // status: "",
                      // search: "",
                      limit,
                      offset,
                    })
                  )
                }
              />

              {/* quiz_id, status, search, limit = 10, offset */}
              {/* <ReusableTable columns={columns} rows={rows} /> */}
            </div>
          )}
          {/* {option_selected === 2 &&
            selectedQuizId &&
            filteredUsersList?.data?.length === 0 && (
              <p
                style={{ textAlign: "center", color: "red", fontSize: "16px" }}
              >
                No Data found
              </p>
            )} */}

          {/* Live Quiz Participants */}
          {option_selected === 3 &&
            selectedQuizId &&
            practiceList?.length > 0 && (
              <div>
                <ReusableTable columns={columns_new} rows={practiceList} />
              </div>
            )}
          {option_selected === 3 &&
            selectedQuizId &&
            practiceList?.length === 0 && (
              <p
                style={{ textAlign: "center", color: "red", fontSize: "16px" }}
              >
                No Data found
              </p>
            )}

          {selectedQuizData && (
            <div className="popup-overlay">
              <div className="popup-content">
                {/* <button onClick={closePopup}>&times;</button> */}
                <img
                  width="20"
                  height="20"
                  src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                  alt="delete-sign--v1"
                  style={{ float: "right", cursor: "pointer" }}
                  onClick={() =>
                    dispatch(
                      setState({
                        key: "selectedQuizData",
                        value: null,
                      })
                    )
                  }
                />
                <h4 style={{ fontSize: "18px", textAlign: "center" }}>
                  {selectedQuizData?.quiz?.quiz_name} ({" "}
                  {selectedQuizData?.quiz?.quiz_type} )
                </h4>
                <h4 style={{ fontSize: "18px", marginBottom: "2%" }}>
                  Result Info
                </h4>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Total Questions</th>
                      <th>Attempted</th>
                      <th>Correct</th>
                      <th>Wrong</th>
                      <th>Total Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{selectedQuizData?.stats?.total_questions || "-"}</td>
                      <td>{selectedQuizData?.stats?.attempted || "-"}</td>
                      <td>{selectedQuizData?.stats?.correct || "-"}</td>
                      <td>{selectedQuizData?.stats?.wrong || "-"}</td>
                      <td>{selectedQuizData?.stats?.total_score || "-"}</td>
                    </tr>
                  </tbody>
                </table>
                <br />{" "}
                <h4 style={{ fontSize: "18px", marginBottom: "2%" }}>
                  Question Info
                </h4>
                <div style={{ height: "40vh", overflow: "auto" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Question</th>
                        <th>Correct Option</th>
                        <th>Selected Option</th>
                        <th>Time Taken</th>
                        <th>Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedQuizData?.answers?.map((q, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{q.question}</td>
                          <td>{q.correct_option}</td>
                          <td>
                            {q.selected_option ? (
                              <span
                                style={{
                                  color:
                                    q.selected_option === q.correct_option
                                      ? "green"
                                      : "red",
                                }}
                              >
                                {q.selected_option}
                              </span>
                            ) : (
                              <span
                                style={{
                                  color: "orange",
                                }}
                              >
                                Not attempted
                              </span>
                            )}
                          </td>
                          <td>
                            {q.time_taken_ms
                              ? `${(q.time_taken_ms / 1000).toFixed(2)} sec`
                              : "N/A"}
                          </td>

                          <td>{q.score}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          {/* Practice Quiz Participants */}
          <style>{`
                .popup-overlay {
                  position: fixed;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background-color: rgba(0,0,0,0.5);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 1000;
                }
        
                .popup-content {
                  background: #fff;
                  padding: 20px;
                  border-radius: 8px;
                  width: 100%;
                  max-width: 1000px;
                  max-height: 90vh;
                  overflow-y: auto;
                  position: relative;
                }
        
                .close-btn {
                  position: absolute;
                  right: 12px;
                  top: 10px;
                  font-size: 24px;
                  background: none;
                  border: none;
                  cursor: pointer;
                }
        
                .close-btn:hover {
                  color: red;
                }
              `}</style>
        </div>
      </div>
    </div>
  );
}
